import type { ConceptDef } from '../types';

export const tactCommunityHelpers: ConceptDef = {
  kind: 'supervisorScored',
  id: 'tact-community-helpers',
  label: 'Expressive Community Helpers',
  category: 'Expressive',
  description: 'Show a community helper; learner names them. Supervisor scores.',
  config: {
    promptMode: 'TEXT',
    prompts: [
      { prompt: '👮 police officer' },
      { prompt: '🧑‍🚒 firefighter' },
      { prompt: '🧑‍⚕️ doctor' },
      { prompt: '🧑‍🏫 teacher' },
      { prompt: '🧑‍🍳 chef' },
      { prompt: '🧑‍🌾 farmer' },
      { prompt: '📮 postman' },
      { prompt: '🧑‍🔧 mechanic' },
    ],
  },
};
